<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">เพิ่มข้อมูลร้านค้า</h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">รหัสร้านค้า:</label>
                <input
                  id="cshCustomerCode"
                  name="cshCustomerCode"
                  v-model="cshCustomerCode"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="รหัสร้านค้า"
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">ชื่อร้านค้า:</label>
                <input
                  id="cshCustomerName"
                  name="cshCustomerName"
                  v-model="cshCustomerName"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="ชื่อร้านค้า"
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">ชื่อร้านค้า 2:</label>
                <input
                  id="cshName2"
                  name="cshName2"
                  v-model="cshName2"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="ชื่อร้านค้า 2"
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">ประเภทร้านค้า:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'cshShopType'"
                  :name="'cshShopType'"
                  :select2-options="cshShopTypeOptions"
                  v-model="cshShopType"
                  ref="cshShopTypeSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">ประเภทการล้างเครื่อง:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'cshShopPMType'"
                  :name="'cshShopPMType'"
                  :select2-options="cshShopPMTypeOptions"
                  v-model="cshShopPMType"
                  ref="cshShopPMTypeSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">สถานะประเภทร้านค้า:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'cshShopGroup'"
                  :name="'cshShopGroup'"
                  :select2-options="cshShopGroupOptions"
                  v-model="cshShopGroup"
                  ref="cshShopGroupSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">ที่อยู่:</label>
                <input
                  id="cshAddress"
                  name="cshAddress"
                  v-model="cshAddress"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="ที่อยู่"
                />
              </div>
            </div>
            
           
             
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">จังหวัด:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'cshProvinceId'"
                  :name="'cshProvinceId'"
                  :select2-options="cshProvinceIdOptions"
                  v-model="cshProvinceId"
                  ref="cshProvinceIdSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">อำเภอ:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'cshAmphurId'"
                  :name="'cshAmphurId'"
                  :select2-options="cshAmphurIdOptions"
                  v-model="cshAmphurId"
                  ref="cshAmphurIdSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">ตำบล:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'cshTumbolId'"
                  :name="'cshTumbolId'"
                  :select2-options="cshTumbolIdOptions"
                  v-model="cshTumbolId"
                  ref="cshTumbolIdSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label>ตัวแทนจำหน่ายย่อย:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      id="cshSubAgent"
                      name="cshSubAgent"
                      v-model="cshSubAgent"
                      type="checkbox"
                      class="form-check-input"
                    />
                    <span></span>
                    เปิดใช้งาน
                  </label>
                </div>
              </div>
            </div>
            <div class="col-xl-12col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">ชื่อ-สกุลผู้ติดต่อ:</label>
                <input
                  id="cshContactFullName"
                  name="cshContactFullName"
                  v-model="cshContactFullName"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="ชื่อ-สกุลผู้ติดต่อ"
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">อีเมล:</label>
                <input
                  id="cshEmail"
                  name="cshEmail"
                  v-model="cshEmail"
                  type="text"
                  maxlength="400"
                  class="form-control"
                  placeholder="อีเมล"
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">เบอร์โทร:</label>
                <input
                  id="cshTel"
                  name="cshTel"
                  v-model="cshTel"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="เบอร์โทร"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">ผู้ดูแลร้านค้า:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'cshAgentCode'"
                  :name="'cshAgentCode'"
                  :select2-options="cshAgentCodeOptions"
                  v-model="cshAgentCode"
                  ref="cshAgentCodeSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">ชื่อเจ้าหน้าที่ดูแล (ตัวแทน):</label>
                <input
                  id="cshContactAgentName"
                  name="cshContactAgentName"
                  v-model="cshContactAgentName"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="ชื่อเจ้าหน้าที่ดูแล (ตัวแทน)"
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">นามสกุลเจ้าหน้าที่ดูแล (ตัวแทน):</label>
                <input
                  id="cshContactAgentLName"
                  name="cshContactAgentLName"
                  v-model="cshContactAgentLName"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="นามสกุลเจ้าหน้าที่ดูแล (ตัวแทน)"
                />
              </div>
            </div>
            <div class="col-xl-6" v-if="$root.canShow('super_admin')">
              <div class="form-group">
                <label class="label">เจ้าหน้าที่ดูแล (Boonrawd)</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'cshEmpId'"
                  :name="'cshEmpId'"
                  :select2-options="cshEmpIdOptions"
                  v-model="cshEmpId"
                  ref="cshEmpIdSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
          </div>
          <!-- Begin: CR-PM-2026 Req 2 — ตั้งค่าระยะ Check-In/Check-Out -->
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <label class="label-required">ตั้งค่าระยะ Check-In/Check-Out:</label>
                <div>
                  <label class="kt-radio kt-radio--bold kt-radio--brand" style="margin-right: 30px;">
                    <input type="radio" v-model="useSettingCheckinRange" :value="true" /> กำหนดตามตั้งค่าพื้นฐาน
                    <span></span>
                  </label>
                  <label class="kt-radio kt-radio--bold kt-radio--brand">
                    <input type="radio" v-model="useSettingCheckinRange" :value="false" /> กำหนดเอง
                    <span></span>
                  </label>
                  <button v-if="!useSettingCheckinRange" type="button" class="btn btn-sm btn-clean btn-icon"
                    @click="resetCheckinRange" title="ใช้ค่า default">
                    <i class="la la-times"></i>
                  </button>
                </div>
                <div v-if="!useSettingCheckinRange" class="mt-2" style="max-width: 300px;">
                  <label class="label-required">ระยะ (เมตร):</label>
                  <input type="number" min="1" max="10000" v-model.number="customCheckInRange"
                    class="form-control" placeholder="ระบุระยะ (เมตร)" name="customCheckInRange"
                    @input="checkCustomCheckInRangeMax" @change="checkCustomCheckInRangeMax" />
                  <span v-if="customCheckInRangeMaxError" class="text-danger small">{{ customCheckInRangeMaxError }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- End: CR-PM-2026 Req 2 -->

          <!-- Begin:Map element -->
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <label>ตำแหน่งที่ตั้ง:</label>
                <div v-if="cshLat === null">
                  <button
                    type="button"
                    class="btn m-btn--pill btn-info btn-block col-xl-2"
                    @click="getMap"
                  >
                    ระบุข้อมูลตำแหน่งที่ตั้ง
                  </button>
                </div>
                <div v-else>
                  <GmapMap
                    :center="{ lat: cshLat, lng: cshLng }"
                    :zoom="15"
                    :clickable="true"
                    @click="updateCoordinates"
                    style="width: 500px; height: 300px"
                  >
                    <gmap-marker
                      :key="index"
                      v-for="(m, index) in markers"
                      :position="m.position"
                      :draggable="true"
                      @drag="updateCoordinates"
                      :clickable="true"
                      @click="updateCoordinates"
                    ></gmap-marker>
                  </GmapMap>
                  <br />
                  <div>
                    <button
                      type="button"
                      class="btn btn-sm btn-secondary"
                      @click="openMap()"
                    >
                      <i class="far fa-map"></i> Open GoogleMaps
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End:Map element -->

          <!-- Begin:Picture element -->
          <div class="row">
              <div class="col-xl-12">
                  <div class="form-group">
                      <label>
                          รูปภาพ:<span class="text-sm text-danger"
                                       style="font-size:small">
                              (เลือกได้เฉพาะสกุลไฟล์ JPG,JPEG,PNG ขนาดไม่เกิน
                              10Mb.)
                          </span>
                      </label>
                      <button type="button"
                              class="btn m-btn--pill btn-info btn-block uploader-btn col-xl-2"
                              @click="uploadFile">
                          <i class="flaticon-upload-1"></i>รูป
                      </button>
                      <div class="row" id="container-img">
                          <div v-for="image in FileUpload"
                               :key="image.pictureId"
                               v-if="image.isLoaded"
                               class="col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap"
                               :id="image.pictureId">
                              <img :src="image.urlImg"
                                   class="img-plant -avatar js-avatar-me img-thumbnail card-img-top"
                                   @error="handleImageError(image)"
                                   @load="handleImageLoad(image)" />
                              <a href="javascript:;"
                                 style="position:absolute;top:10px;right:20px;"
                                 class="btn m-btn--pill btn-danger m-btn btm-remove-img-plant close"
                                 @click="removeImage(image.pictureId)">
                                  <span class="m--font-inverse-danger la la-trash"></span>
                              </a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <!-- End:Picture element -->

          <!-- Begin:InActiveStatus element -->
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <label>สถานะ:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      id="cshInActiveStatus"
                      name="cshInActiveStatus"
                      v-model="cshInActiveStatus"
                      type="checkbox"
                      class="form-check-input"
                    />
                    เปิดใช้งาน
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-xl-12">
              <div v-if="cshInActiveStatus" class="form-group">
                <label>เหตุผล:</label>
                <div class="form-check" v-for="data in cshActive">
                  <label class="form-check-label kt-checkbox">
                    <input
                      id="statusCode"
                      name="statusCode"
                      v-model="cshStatus"
                      :value="data.statusCode"
                      type="radio"
                      class="form-check-input"
                    />
                    {{ data.statusName }}
                    <span></span>
                  </label>
                  <br />
                </div>
              </div>
              <div v-if="!cshInActiveStatus" class="form-group">
                <label>เหตุผล:</label>
                <div class="form-check" v-for="data in cshInActive">
                  <label class="form-check-label kt-checkbox">
                    <input
                      id="statusCode"
                      name="statusCode"
                      :value="data.statusCode"
                      v-model="InActiveStatus"
                      type="radio"
                      class="form-check-input"
                    />
                    {{ data.statusName }}
                    <span></span>
                  </label>
                  <br />
                </div>
              </div>
            </div>

            <div v-if="this.$root.canShow([''])" class="col-xl-12">
              <div class="form-group">
                <label>[PM] ปลด validate การตรวจสอบหน้าข้อมูลร้านค้า</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      id="cShIgnoreBarcodeValidation"
                      name="cShIgnoreBarcodeValidation"
                      v-model="cShIgnoreBarcodeValidation"
                      type="checkbox"
                      class="form-check-input"
                    />
                    เปิดใช้งาน
                    <span></span>
                  </label>
                </div>
              </div>
            </div>

             <div v-if="this.$root.canShow([''])" class="col-xl-12">
              <div class="form-group">
                <label>[PM] ตั้งค่าใช้ PM (รูปแบบพิเศษ)</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      id="cShIsSpecialPM"
                      name="cShIsSpecialPM"
                      v-model="cShIsSpecialPM"
                      type="checkbox"
                      class="form-check-input"
                    />
                    เปิดใช้งาน PM (รูปแบบพิเศษ)
                    <span></span>
                  </label>
                </div>
               </div>
              </div>

          </div>
          <!-- End:InActiveStatus element -->
        </div>
      </div>
      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="submit" class="btn btn-primary">
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";
import plupload from "plupload";
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCeGao-PkONmiyVksl46W_OUHt854bcrqE",
    libraries: "places",

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
});

export default {
  components: {
    select2,
  },
  name: "GoogleMap",
  data: function() {
    var self = this;

    return {
      cshCustomerCode: null,
      cshCustomerName: null,
      cshName2: null,
      cshShopType: null,
      cshShopGroup: null,
      cshShopPMType : null,
      cshAddress: null,
      cshProvinceId: null,
      cshAmphurId: null,
      cshTumbolId: null,
      cshSubAgent: false,
      cshContactFullName: null,
      cshEmail: null,
      cshTel: null,
      cshAgentCode: null,
      cshContactAgentName: null,
      cshContactAgentLName: null,
      cshEmpId: null,
      cshInActiveStatus: true,
      cShIgnoreBarcodeValidation: false,
      cShIsSpecialPM : false,
      cshLat: null,
      cshLng: null,
      // CR-PM-2026 Req 2 — per-shop radius config (default = use Setting)
      useSettingCheckinRange: true,
      customCheckInRange: null,
      customCheckInRangeMaxError: null,
      markers: [],
      FileUpload: [],
      
      cshStatus: "STATUS_SHOP_ACTIVE_NEW",
      InActiveStatus: "STATUS_SHOP_INACTIVE_CLOSE",
      
      cshActive: [],
      cshInActive: [],
      cshShopTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ShopType/Select2SearchShopType",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cshShopGroupOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ShopType/Select2SearchShopGroup",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cshShopPMTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Select2MasterShopTypePM",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cshEmpIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Employee/Select2Employee",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cshProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cshAmphurIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              provinceId: self.cshProvinceId,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cshTumbolIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchTumbol",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              ampherId: self.cshAmphurId,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cshAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              department: [],
              province_id: [],
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
methods: {
    // CR-PM-2026 Req 2 — reset to default (use Setting)
    resetCheckinRange() {
        this.useSettingCheckinRange = true;
        this.customCheckInRange = null;
        this.customCheckInRangeMaxError = null;
    },
    checkCustomCheckInRangeMax(e) {
      const raw = e.target.value;
      const val = Number(raw);
      if (raw !== "" && !isNaN(val) && val > 10000) {
        this.customCheckInRangeMaxError = "ไม่สามารถกำหนดระยะทางเกิน 10,000 เมตร ได้";
        // Clamp value back to 10000 (block typing beyond)
        this.customCheckInRange = 10000;
        this.$nextTick(() => { if (e.target) e.target.value = 10000; });
      } else {
        this.customCheckInRangeMaxError = null;
      }
    },
    handleImageError(image) {
        image.isLoaded = false;
        // console.error("รูปภาพโหลดไม่สำเร็จ:", image.fileName);
    },
    handleImageLoad(image) {
        image.isLoaded = true;
        // console.log("รูปภาพโหลดสำเร็จ:", image.fileName);
    },
    removeImage(pictureId) {
        Swal.fire({
            title: "ยืนยันคำสั่ง",
            text: "คุณต้องการลบรูปภาพนี้หรือไม่",
            confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
            confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",
            showCancelButton: true,
            cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
            cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon"
        }).then((result) => {
            if (result.value) {
                this.FileUpload = this.FileUpload.filter(
                    (img) => img.pictureId !== pictureId
                );
                Swal.fire("ลบสำเร็จ!", "ลบรูปภาพเรียบร้อยแล้ว", "success");
            }
        });
    },
    uploadFile() {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/jpeg,image/png,image/jpg";
        input.click();

        input.addEventListener("change", (event) => {
            const files = event.target.files;
            Array.from(files).forEach((file) => {
                if (
                    ["image/jpeg", "image/jpg", "image/png"].includes(file.type) &&
                    file.size <= 10 * 1024 * 1024
                ) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const newImage = {
                            pictureId: Date.now().toString(),
                            fileName: file.name,
                            urlImg: e.target.result,
                            fileDataContext: file,
                            isNew: true,
                            isLoaded: true,
                        };
                        this.FileUpload.push(newImage);
                    };
                    reader.readAsDataURL(file);
                } else {
                    alert(
                        "กรุณาเลือกไฟล์ภาพที่ถูกต้อง (JPG, JPEG, PNG ขนาดไม่เกิน 10MB)"
                    );
                }
            });
        });
    },
    //formSubmit: function (e) {
    async formSubmit(e) {
      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      let router = this.$router;
      let self = this;


        let uploadedFiles = [];
        let isUploadFile = false;

        for (let file of this.FileUpload) {
            if (file.isNew && file.fileDataContext) {
                try {
                    isUploadFile = true;
                    const formData = new FormData();
                    formData.append("File", file.fileDataContext);
                    formData.append("IsMaster", true);
                    formData.append("FolderName", "MasterProduct");

                    const uploadResponse = await axios.post("/Api/File/FileUpload", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    });

                    console.log('uploadResponse', uploadResponse)

                    uploadedFiles.push({
                        contentType: "-",
                        downloadUrl: uploadResponse.data.fileUrl,
                        fileInfoId: uploadResponse.data.fileInfoId,
                        fileName: uploadResponse.data.fileInfoId,
                        gridFsId: uploadResponse.data.gridFsId,
                        sysName: "-",
                    });
                } catch (error) {
                    console.error("เกิดข้อผิดพลาดในการอัปโหลดไฟล์:", error);
                }
            } else if (!file.isNew) {
                uploadedFiles.push(file);
            }
        }

     const picturesData = isUploadFile && uploadedFiles.length > 0 ? uploadedFiles : [];

      axios
        .post("/Api/Shop", {
          CustomerCode: this.cshCustomerCode,
          CustomerName: this.cshCustomerName,
          Name2: this.cshName2,
          ShopTypeId: this.cshShopType,
          ShopPMType : this.cshShopPMType,
          ShopGroupId: this.cshShopGroup,
          Address: this.cshAddress,
          ProvinceId: this.cshProvinceId,
          AmphurId: this.cshAmphurId,
          TumbolId: this.cshTumbolId,
          ContactFullName: this.cshContactFullName,
          Email: this.cshEmail,
          Tel: this.cshTel,
          AgentCode: this.cshAgentCode,
          Latitude: this.cshLat,
          Longitude: this.cshLng,
          ContactAgentName: this.cshContactAgentName,
          ContactAgentLastName: this.cshContactAgentLName,
          EmployeeId: this.cshEmpId,
          ShopPictures: picturesData,//this.cshImgUpload,
          SubAgent: this.cshSubAgent,
          InActiveStatus: !this.cshInActiveStatus,
          Reason:
            this.cshInActiveStatus == true
              ? this.cshStatus
              : this.InActiveStatus,
          ignoreBarcodeValidation: this.cShIgnoreBarcodeValidation,
          isSpecialPM : this.cShIsSpecialPM,
          // CR-PM-2026 Req 2 — radius
          UseSettingCheckinRange: this.useSettingCheckinRange,
          CheckInRange: this.useSettingCheckinRange ? null : this.customCheckInRange,
        })
        .then(function(response) {
          if (response.data.status) {
            KTApp.unblockPage();
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            //console.log(response);
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    getMap: function() {
      //get current lat,lon by IP
      navigator.geolocation.getCurrentPosition((position) => {
        this.cshLat = position.coords.latitude;
        this.cshLng = position.coords.longitude;
        this.markers = [
          {
            position: { lat: this.cshLat, lng: this.cshLng },
            animation: google.maps.Animation.DROP,
          },
        ];
      });
    },
    //get current lat,lng (dragable)
    updateCoordinates(location) {
      this.cshLat = location.latLng.lat();
      this.cshLng = location.latLng.lng();
      map: this.map;
      this.markers = [{ position: { lat: this.cshLat, lng: this.cshLng } }];
    },
    deleteImg() {
      $("#container-img").on("click", ".btm-remove-img-plant", function(e) {
        e.preventDefault();
        var $img = $(this);
        Swal.fire({
          title: "ยืนยันคำสั่ง",
          text: "คุณต้องการลบรูปภาพนี้หรือไม่",
          icon: "danger",
          confirmButtonText:
            "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
          confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",

          showCancelButton: true,
          cancelButtonText:
            "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
          cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon",

          // imageUrl: Setting.rootPath + "uploads/" + $img.data("file-newid"),
          imageWidth: 400,
          imageAlt: "Custom image",
          buttons: true,
          dangerMode: true,
        }).then(function(result) {
          let file = $img.data("file-newid");
          // let url = Setting.rootPath + "Api/File/DeleteFile/" + file;
          let url = "/Api/File/DeleteFile/" + file;
          if (result.value) {
            if ($img.data("type") != "1") {
              $.ajax({
                type: "Get",
                url: url,
                cache: false,
                success: function(response) {
                  var fileId = "#" + $img.data("file-id");
                  $(fileId).remove();
                  Swal.fire("เรียบร้อย!", "ลบรูปภาพเรียบร้อย", "success");
                },
                failure: function(response) {
                  swal(
                    "Internal Error",
                    "Oops, your note was not saved.", // had a missing comma
                    "error"
                  );
                },
              });
            } else {
              var fileId = "#" + $img.data("file-id");
              $(fileId).remove();
              Swal.fire("เรียบร้อย!", "ลบรูปภาพเรียบร้อย", "success");
            }
          }
        });
      });
    },
    initPlUploader() {
      console.log("initPlUploader");
      let self = this;
      var uploader = new plupload.Uploader({
        runtimes: "html5,flash,silverlight,html4",
        browse_button: "uploader-shop", // you can pass in id...
        //url: Setting.rootPath + "Components/Plupload?reference=" + self.uuid, // คือ Url มาตรฐานของ plupload
        url: "/Components/Plupload?reference=" + self.uuid,

        chunk_size: "1mb",
        max_retries: 5,
        filters: {
          max_file_size: "10mb",
          mime_types: [
            { title: "Image files", extensions: "jpg,jpeg,png,JPG,JPEG,PNG" },
          ],
        },
        resize: {
          width: 300,
          quality: 100,
        },
        init: {
          PostInit: function() {},

          FilesAdded: function(up, files) {
            var $uploadBtn = $(up.settings.browse_button[0]);
            var $imageContainer = $("#container-img");
            //mApp.block($imageContainer.parents('.m-portlet__body'))

            var removeFiles = [];
            plupload.each(files, function(file) {
              if (
                $('img[data-file-name="' + file.name + '"]', $imageContainer)
                  .length == 0
              ) {
                var nativeData = file.getNative();
                if (typeof FileReader != "undefined") {
                  var image_holder = $(
                    '<div class="col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap" id="' +
                      file.id +
                      '"></div>'
                  );
                  $(
                    '<img class="img-plant -avatar js-avatar-me img-thumbnail card-img-top" style="display:none" data-file-id="' +
                      file.id +
                      '" data-file-name="' +
                      file.name +
                      '" data-file-uploaded="false" alt="' +
                      file.name +
                      '" /><div id="myProgress" class=" progress' +
                      file.id +
                      '"><div id="myBar' +
                      file.id +
                      '" class="progress-bar bg-success"><b></b></div ></div >'
                  ).appendTo(image_holder);
                  image_holder.appendTo($imageContainer);
                  var reader = new FileReader();
                  reader.onload = function(e) {
                    $("img[data-file-id=" + file.id + "]")
                      .attr("src", e.target.result)
                      .show();
                  };
                  reader.readAsDataURL(nativeData);
                }
              } else {
                removeFiles.push(file);
              }
            });

            if (removeFiles.length > 0) {
              for (var i = 0; i < removeFiles.length; i++) {
                up.removeFile(removeFiles[i]);
              }

              swal("ขออภัย", "ไม่สามารถเลือกไฟล์ซ้ำได้", "warning");
            }

            up.start();
          },

          // BeforeUpload: function(up, file) {
          //   check_object_radio();
          //   set_upload_param(up, file.name, true);
          // },

          UploadProgress: function(up, file) {
            document
              .getElementById(file.id)
              .getElementsByTagName("b")[0].innerHTML =
              "<span>" + file.percent + "%</span>";
            $("#myBar" + file.id + " .progress-bar .bg-success").css(
              "width",
              file.percent - 1 + "%"
            );
          },

          FileUploaded: function(up, file, info) {
            console.log("FileUploaded");
            if (info.response == "OK") {
              var $uploadBtn = $(up.settings.browse_button[0]);
              var $imageContainer = $("#container-img");
              var $img = $("img[data-file-id=" + file.id + "]");
              $img.attr("data-file-uploaded", "true");
              //var url = Setting.rootPath + "Api/File/MoveFile";
              var url = "/Api/File/MoveFile";
              var ref = $("#uploader-shop").data("ref");
              $.ajax({
                url: url,
                type: "post",
                data: {
                  FileID: $img.data("file-id"),
                  FileName: $img.data("file-name"),
                  Reference: ref,
                },
                datatype: "json",
                ContentType: "application/json;utf-8",
              }).done(function(data) {
                /*ถ้าสำเร็จให้ทำอะไรต่อ */
                $("#myBar" + file.id).remove();
                $(
                  '<div id="myBar' +
                    file.id +
                    '" class="progress-bar bg-success" style="width:100%"><b>100%</b></div >'
                ).appendTo($(".progress" + file.id));
                $(
                  '<a href="javascript:;" style="position:absolute;top:10px;right:20px;" class="btn m-btn--pill btn-danger m-btn btm-remove-img-plant close" data-file-newid="' +
                    data.fileName +
                    '" data-file-id="' +
                    file.id +
                    '" ><span class="m--font-inverse-danger la la-trash"></span></a>'
                ).appendTo("#" + data.fileID);
                // $("#" + file.id).removeClass(
                //   "kt-spinner kt-spinner--lg kt-spinner--warning"
                // );
                $("#" + file.id).add;
              });
            }
          },

          Error: function(up, err) {
            $("#myBar" + err.file.id).remove();
            $(
              '<div id="myBar' +
                err.file.id +
                '" class="myBar" style="background-color:red;width:100%"><b>false</b></div >'
            ).appendTo($(".progress" + err.file.id));
            $("#" + err.file.id).removeClass(
              "kt-spinner kt-spinner--lg kt-spinner--warning"
            );
            var a = $(
              '<a class="btn m-btn--pill btn-info m-btn btm-reload-img-plant"><span class="fas fa-redo-alt"></span></a>'
            );
            a.appendTo("#" + err.file.id);
            a.data("up", up);
            a.data("file", err.file);
            a.click(function() {
              var $this = $(this);
              var myUp = $this.data("up");
              var myFile = $this.data("file");
              myFile.status = plupload.QUEUED;
              $("#" + myFile.id).remove();
              myUp.addFile(myFile);
            });
            var d = $(
              '<a class="btn m-btn--pill btn-danger m-btn btm-delete-img-plant" style="position:absolute;top:10px;right:20px;"><span class="far fa-trash-alt"></span></a>'
            );
            d.appendTo("#" + err.file.id);
            d.click(function() {
              $("#" + err.file.id).remove();
            });
          },
        },
      });
      uploader.init();
    },
    openMap() {
      var self = this;
      window.open(
        "https://www.google.com/maps/search/?api=1&query=" +
          self.cshLat +
          "," +
          self.cshLng,
        "_blank"
      );
    },
    getStatusShop() {
      var self = this;
      axios.get("/Api/Shop/StatusShop").then(function(response) {
        if (response.status == 200) {
          self.cshActive = response.data.filter(
            (o) => o.statusGroup == "STATUS_SHOP_ACTIVE"
          );
          self.cshInActive = response.data.filter(
            (o) => o.statusGroup == "STATUS_SHOP_INACTIVE"
          );
        }
      });
    },
    // getPMTypeShop() {
    //   var self = this;
    //   axios.get("/Api/Variables/Select2MasterShopTypePM").then(function(response) {
    //     if (response.status == 200) {
    //       self.cshActive = response.data.filter(
    //         (o) => o.statusGroup == "STATUS_SHOP_ACTIVE"
    //       );
    //       self.cshInActive = response.data.filter(
    //         (o) => o.statusGroup == "STATUS_SHOP_INACTIVE"
    //       );
    //     }
    //   });
    // },
  },
  async mounted() {
    let self = this;
    let router = this.$router;

    

    self.getStatusShop();

    // set validation rules
    $(this.$refs.form).validate({
      rules: {
        cshCustomerCode: "required",
        cshCustomerName: "required",
        cshShopType: "required",
        cshShopGroup: "required",
        cshShopPMType : "required",
        // cshEmail: {
        //   emailNullable: true,
        // },
        cshAddress: "required",
        cshProvinceId: "required",
        cshAmphurId: "required",
        cshTumbolId: "required",
        cshTel: "required",
        cshAgentCode: "required",
        cshName2: "required",
        // CR-PM-2026 Issue 14: required เฉพาะกรณี "กำหนดเอง" (useSettingCheckinRange=false)
        customCheckInRange: {
          required: function() { return !self.useSettingCheckinRange; }
        },
      },
      messages: {
        cshCustomerCode: "กรุณากรอกรหัสร้านค้า",
        cshCustomerName: "กรุณากรอกชื่อร้านค้า",
        cshShopType: "กรุณาเลือกประเภทร้านค้า",
        cshShopPMType : "ประเภทการล้างเครื่อง",
        cshShopGroup: "กรุณาเลือกสถานะประเภทร้านค้า",
        // cshEmail: {
        //   emailNullable: "กรุณากรอกรูปแบบอีเมลให้ถูกต้อง",
        // },
        cshAddress: "กรุณากรอกที่อยู่",
        cshProvinceId: "กรุณาเลือกประเภทจังหวัด",
        cshAmphurId: "กรุณาเลือกประเภทอำเภอ",
        cshTumbolId: "กรุณาเลือกประเภทตำบล",
        cshTel: "กรุณากรอกเบอร์โทร",
        cshAgentCode: "กรุณาเลือกผู้ดูแลร้านค้า",
        cshName2: "กรุณากรอกชื่อร้านค้า 2",
        customCheckInRange: "กรุณาระบุระยะ (เมตร)",
      },
    });
  },
};
</script>

<style lang="scss">
#myProgress {
  width: 100%;
  background-color: #ddd;
}

.myBar {
  width: 10%;
  height: 30px;
  background-color: #4caf50;
  text-align: center;
  line-height: 30px;
  color: white;
}

.btm-reload-img-plant {
  position: absolute;
  top: 5px;
  right: 20px;
}
.btm-delete-img-plant {
  position: absolute;
  top: 5px;
  right: 70px;
}
.btm-remove-img-plant {
  position: absolute;
  top: 5px;
  right: 20px;
}

.select2,
.select2-dropdown {
  font-size: 1rem;
}

@media (max-width: 425px) {
  .m-body .m-content {
    padding: 20px 5px;
  }
}

@media (max-width: 1200px) {
  .m-wizard.m-wizard--2 {
    margin-top: 8rem !important;
  }

  #activity_wizard .m-wizard__form .m-form .m-portlet__body {
    padding: 2.2rem 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// App/Components/Master/Shop/CreateShop.vue